import React from 'react';
import { FaMapMarkerAlt, FaCar } from 'react-icons/fa';
import FallbackMap from '../DELIVERY/Map/FallbackMap';

const LiveMapSection = ({ 
    pickupPos, 
    dropoffPos, 
    handleMapClick, 
    selectedDriver, 
    setSelectedDriver, 
    clearPositions,
    style
}) => (
    <div 
        className={`live-map-block ${selectedDriver ? 'has-driver' : ''}`}
        style={{
            position: 'relative',
            width: '100%',
            height: '100%',
            minHeight: '100%',
            borderRadius: '0px',
            overflow: 'hidden',
            border: 'none',
            margin: '0',
            background: '#141414',
            ...style
        }}
    >
        <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
            <FallbackMap
                pickupPos={pickupPos}
                dropoffPos={dropoffPos}
                onMapClick={handleMapClick}
                onDriverSelect={setSelectedDriver}
                height="100%"
                showDrivers={true}
                centerOnUser={true}
            />
        </div>
        <div style={{ position: 'absolute', top: '16px', left: '16px', zIndex: 10, display: 'flex', flexDirection: 'column', gap: '8px', pointerEvents: 'auto' }}>
            {(pickupPos || dropoffPos || selectedDriver) && (
                <button 
                    onClick={clearPositions}
                    style={{
                        background: 'rgba(30, 41, 59, 0.9)',
                        color: '#ef4444',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        padding: '8px 14px',
                        borderRadius: '12px',
                        fontSize: '0.8rem',
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        cursor: 'pointer',
                        backdropFilter: 'blur(4px)',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                    }}
                >
                    <FaMapMarkerAlt /> Limpiar Ruta
                </button>
            )}
            {selectedDriver && (
                <button 
                    style={{
                        background: 'var(--bry-accent)',
                        color: 'var(--bry-white)',
                        border: 'none',
                        padding: '8px 14px',
                        borderRadius: '12px',
                        fontSize: '0.8rem',
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        cursor: 'pointer',
                        boxShadow: '0 4px 12px rgba(14, 171, 176, 0.3)'
                    }}
                >
                    <FaCar /> {selectedDriver.name || 'Conductor'}
                </button>
            )}
        </div>
    </div>
);

export default LiveMapSection;

